import { useState, useRef, useEffect } from "react";

export function useDebounceCallback(callback: (...args: any[]) => void, delay: number, dependencies: any[]) {
    const [args, setArgs] = useState(null);
    const lastArgs = useRef(args);

    useEffect(() => {
        const handler = setTimeout(() => {
            // @ts-expect-error
            if (args && lastArgs.current.id === args.id) {
                // @ts-expect-error
                callback(...args);
            }
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [args, delay, callback]);

    // @ts-expect-error
    return (...newArgs) => {
        // @ts-expect-error
        lastArgs.current = newArgs;
        // @ts-expect-error
        setArgs(newArgs);
    };
}